import React, { Fragment, isValidElement } from 'react';

export function interpolate(text, params, single) {
  let hasElements = false;

  const parts = text.split(/(?=[^{}]?)({{(?!{)[^{}]+}})/gm)
    .map((part, idx) => {
      if (!part.startsWith('{{') || !part.endsWith('}}')) return part;
      
      const paramName = part.slice(2, -2);
      const interpolator = single? params : params[paramName];

      return typeof interpolator === 'function'
        ? interpolator(paramName, idx)
        : interpolator;
    })
    .flatMap(item => typeof item === 'string'
      ? handleNewlines(item)
      : item
    )
    .map(((item, idx) => {
      if (isValidElement(item)) {
        hasElements = true;
        return <Fragment key={idx}>{item}</Fragment>;
      }
      return `${item == null ? '' : item}`;
    }));

  return hasElements
    ? parts
    : parts.join('');
}

export function handleNewlines(str) {
  return str
    .split(/\n/gm)
    .flatMap((part, idx, arr) => idx < arr.length - 1 ? [part, <br />] : [part]);
}

export default interpolate;